import {ReactNode} from "react";

import {EmptyTable, EmptyTableProps} from "@/components/table/subComponents/EmptyTable/EmptyTable.tsx";

export interface TableEmptyStateCtaProps extends Omit<EmptyTableProps, "children"> {
  title: string;
  cta?: ReactNode;
  header?: ReactNode;
  description?: ReactNode;
}

export const TableEmptyStateCta = ({title, cta, header, description, ...emptyTableProps}: TableEmptyStateCtaProps) => {
  return (
    <EmptyTable {...emptyTableProps}>
      <div className="m-4 d-flex flex-column align-items-center justify-content-center gap-3 text-center">
        {header}
        <div>
          <div className={description ? "pulseTextH3Bold" : "pulseTextBodyBold"}>{title}</div>
          {description && <div className="pulseTextBodySmall mt-2">{description}</div>}
        </div>
        {cta}
      </div>
    </EmptyTable>
  );
};
